import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Addresses } from '../../types/address';
import { Department } from '../../types/department';
import { EmployeeTypes } from '../../types/employeeTypes';
import { JobTitle } from '../../types/jobTitle';
import { Managers } from '../../types/managers';
import { GetById } from '../../types/teamGetById';
import { AddTeamMembers, TeamMember } from '../../types/teamMembers';
import { WorkerTypes, WorkLocation, WorkLocationss } from '../../types/workLocations';

interface RootState {
    teamMembers: TeamMember[];
    address:Addresses[];
    worklocations:WorkLocation[];
    Jobtitle:JobTitle[];
    workerType:WorkerTypes[];
    department:Department[];
    addteam:AddTeamMembers[];
    managerlist:Managers[];
    organization:WorkLocationss[];
    getbyidteam:GetById[];
    employtype:EmployeeTypes[];
    selectedteam: TeamMember | null;
    currentPage: number;
  totalPages: number;
  totalCount: number;
  pageSize: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
 
    
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: RootState = {
  teamMembers: [],
  address:[],
  worklocations:[],
  Jobtitle:[],
  workerType:[],
  department:[],
  addteam:[],
  managerlist:[],
  organization:[],
  getbyidteam:[],
  employtype:[],
  selectedteam:null,
  status: 'idle',
  error: null,
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  pageSize: 10,
  hasPreviousPage: false,
  hasNextPage: false,
};


export const teamMemberSlice = createSlice({
  name: 'Team Member',
  initialState,
  reducers: {
    setTeamMember: (state, action: PayloadAction<TeamMember[]>) => {
      state.teamMembers = action.payload;
  
      state.status = 'succeeded';
      state.error = null;
    },
    teamMemberAdd: (state, action: PayloadAction<TeamMember>) => {
      state.teamMembers.push(action.payload);
      state.status = 'succeeded';
      state.error = null;
    },
    teamMemberUpdate: (state, action: PayloadAction<TeamMember>) => {
      const index = state.teamMembers.findIndex((c) => c.id === action.payload.id);
      if (index !== -1) {
        state.teamMembers[index] = action.payload;
      }
      state.status = 'succeeded';
      state.error = null;
    },

    
    setLoading: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.status = 'failed';
      state.error = action.payload;
    },
    addressAdd:(state,action:PayloadAction<Addresses>)=>{
      state.address.push(action.payload);
      state.status='succeeded';
      state.error=null;

    },
    setAddress:(state,action:PayloadAction<Addresses[]>)=>{
      state.address=action.payload;
      state.status='succeeded';
      state.error=null;

    },
    setWorklocation:(state,action:PayloadAction<WorkLocation[]>)=>{
      state.worklocations=action.payload;
      state.status='succeeded';
      state.error=null
    },
    SetJobTitle:(state,action:PayloadAction<JobTitle[]>)=>{
      state.Jobtitle=action.payload;
      state.status="succeeded";
      state.error=null;
    },
    SetWorkerTypes:(state,action:PayloadAction<WorkerTypes[]>)=>{
      state.workerType=action.payload;
           state.status='succeeded';
      state.error=null;
    },
    setDepartment: (state, action: PayloadAction<Department[]>) => {
      state.department = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    RoleAdd:(state,action:PayloadAction<AddTeamMembers>)=>{
      state.addteam.push(action.payload);
      state.status='succeeded';
      state.error=null;
    },
    RoleUpdate:(state,action:PayloadAction<AddTeamMembers>)=>{
      const index = state.addteam.findIndex((c) => c.id === action.payload.id);
      if (index !== -1) {
        state.addteam[index] = action.payload;
      }
      state.status = 'succeeded';
      state.error = null;
    },
    setManagers:(state,action:PayloadAction<Managers[]>)=>{
      state.managerlist=action.payload;
      state.status='succeeded';
      state.error=null;
    },
    setPagination: (state, action: PayloadAction<Partial<RootState>>) => {
      state.currentPage = action.payload.currentPage ?? state.currentPage;
      state.totalPages = action.payload.totalPages ?? state.totalPages;
      state.totalCount = action.payload.totalCount ?? state.totalCount;
      state.pageSize = action.payload.pageSize ?? state.pageSize;
      state.hasPreviousPage = action.payload.hasPreviousPage || state.hasPreviousPage;
      state.hasNextPage = action.payload.hasNextPage || state.hasNextPage;
    },
    setOrganization:(state,action:PayloadAction<WorkLocationss[]>)=>{
      state.organization=action.payload;
      state.status='succeeded';
      state.error=null;
    },
    setGetById:(state,action:PayloadAction<GetById[]>)=>{
      state.getbyidteam=action.payload;
      state.status='succeeded';
      state.error=null
    },
    setemployementstatus:(state,action:PayloadAction<EmployeeTypes[]>)=>{
      state.employtype=action.payload;
      state.status='succeeded';
      state.error=null;
    },
    SelectedIndividualTeam:(state,action:PayloadAction<TeamMember>)=>{
      state.selectedteam=action.payload;
      state.status='succeeded';
      state.error=null;
    }

  },
  
});

export const { setTeamMember, teamMemberAdd,teamMemberUpdate , setLoading, setError,addressAdd,setAddress,setWorklocation,SetJobTitle,SetWorkerTypes,setDepartment,RoleAdd,setManagers,setPagination,setOrganization,setGetById,RoleUpdate,SelectedIndividualTeam} = teamMemberSlice.actions;
export default teamMemberSlice.reducer;
